import { render, staticRenderFns } from "./storeMaterial.vue?vue&type=template&id=c1ecf2d0&scoped=true&"
import script from "./storeMaterial.vue?vue&type=script&lang=js&"
export * from "./storeMaterial.vue?vue&type=script&lang=js&"
import style0 from "./storeMaterial.vue?vue&type=style&index=0&id=c1ecf2d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ecf2d0",
  null
  
)

export default component.exports